import React, { useMemo } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  LinearProgress,
  Tooltip,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import styled from 'styled-components'

import { useAppSelector } from 'redux/Hook'
import ActionCard from 'components/Shared/ActionCard'
import { TAResponseProps } from 'types/TextAnalysis'
import { cardUserAndMeta } from './CardListHeader'
import {
  renderCardBodyContent,
  renderCardTitleContent,
} from './CardListContent'
import ChipsList from 'components/Shared/ChipsList'
import { renderCardMetricsContent } from './CardListFooter'

interface IdeasCommentDialogProps {
  open: boolean
  onClose: () => void
  renderTagMenu: (cardData: TAResponseProps, index: number) => any
}

const IconStyled = styled(IconButton)`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
`

const DialogContentStyled = styled(DialogContent)`
  padding: 0;
`

const renderCardTags = (item: TAResponseProps) => (
  <ChipsList
    chipData={item?.tags || []}
    size="small"
    chipKey="id"
    chipLabel="name"
    variant="outlined"
  />
)

const IdeasCommentDialog: React.FC<IdeasCommentDialogProps> = ({
  open,
  onClose,
  renderTagMenu,
}) => {
  const {
    data: singleItem,
    pending,
    done,
  } = useAppSelector(
    (state) => state.textAnalysis.contributions.singleContribution,
  )

  const data = useMemo(() => singleItem as TAResponseProps, [singleItem])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="ideas-comment-dialog-title"
      aria-describedby="ideas-comment-dialog-description"
    >
      {pending && !done && <LinearProgress />}
      {!pending && done && (
        <DialogContentStyled>
          <ActionCard
            id="ideas-comment-dialog"
            index={0}
            cardMeta={cardUserAndMeta(data)}
            cardTitle={renderCardTitleContent(data)}
            cardContent={renderCardBodyContent(data)}
            cardTagMenu={renderTagMenu(data, 0)}
            cardTags={renderCardTags(data)}
            cardMetrics={renderCardMetricsContent(data)}
          />
          <Tooltip title="Close" placement="left">
            <IconStyled aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconStyled>
          </Tooltip>
        </DialogContentStyled>
      )}
    </Dialog>
  )
}

export default React.memo(IdeasCommentDialog)
